(function ($) {
  jQuery(function () {
    // element argument can be a selector string
    //   for an individual element
    $(".main-carousel").flickity({
      // options
      cellAlign: "left",
      draggable: false,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: 7000,
      selectedAttraction: 0.015,
      wrapAround: true,
      //   friction: 0.15,
    });
  });
})(jQuery);
